<template>
  <tk-container
    disableScroll
  >
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </tk-container>
</template>
<script>
export default {
  name: 'home-layout',
  data () {
    return {
    }
  },
}
</script>
<style lang="scss" scoped>
</style>
